/**
 * Cart Minimum Order Threshold
 *
 * Enforces ₹450 minimum order across ALL checkout paths.
 * Reads cart data directly from intercepted API responses
 * for instant UI updates — no extra network requests.
 */
(function () {
  'use strict';

  var THRESHOLD = 45000;
  var CHEAPEST = 9500;
  var isLoggedIn = window.__akunkaCustomerLoggedIn || false;
  var lastCartState = null;

  function formatMoney(cents) {
    return '\u20B9' + Math.round(cents / 100);
  }

  /* ========== Core: update all UI from cart data ========== */

  function updateAllUI(cart) {
    lastCartState = cart;
    var cartTotal = cart.original_total_price;
    var cartTotalDiscounted = cart.total_price;
    var delta = THRESHOLD - cartTotal;
    var deltaDiscounted = THRESHOLD - cartTotalDiscounted;

    var state;
    if (cart.item_count === 0) {
      state = 'empty';
    } else if (delta <= 0) {
      state = 'above';
    } else if (deltaDiscounted <= 0) {
      state = 'above';
    } else if (delta < CHEAPEST && isLoggedIn) {
      state = 'nearsigned';
    } else if (delta < CHEAPEST) {
      state = 'nearguest';
    } else {
      state = 'below';
    }

    var fillPct = Math.min(Math.round(cartTotal / THRESHOLD * 100), 100);
    var shouldBlock = (state === 'below' || state === 'nearguest' || state === 'skipstate' || state === 'empty');

    document.querySelectorAll('.cart-threshold').forEach(function (el) {
      var currentState = el.getAttribute('data-state');
      if (currentState === 'skipstate' && state !== 'above' && state !== 'empty') {
        updateDeltaText(el, delta);
        updateProgressBar(el, fillPct, state);
        return;
      }
      el.setAttribute('data-state', state);
      updateProgressBar(el, fillPct, state);
      updateDeltaText(el, delta);
      bindSkipButton(el);
      bindCrosssellButtons(el);
      el.classList.remove('cart-threshold--show-perks');
    });

    if (shouldBlock) {
      document.body.classList.remove('cart-threshold-met');
    } else {
      document.body.classList.add('cart-threshold-met');
    }

    controlCheckoutButtons(shouldBlock);

    /* Update cart bubble count */
    var bubble = document.querySelector('.cart-count-bubble span');
    if (bubble) bubble.textContent = cart.item_count;
  }

  function updateProgressBar(container, fillPct, state) {
    var bar = container.querySelector('.cart-threshold__bar-fill');
    if (bar) bar.style.width = fillPct + '%';
    var track = container.querySelector('.cart-threshold__bar-track');
    if (track) track.style.display = (state === 'above' || state === 'empty') ? 'none' : '';
  }

  function updateDeltaText(container, delta) {
    var formatted = formatMoney(delta);
    var deltaMsg = container.querySelector('.cart-threshold__delta-msg');
    if (deltaMsg) deltaMsg.textContent = 'Add ' + formatted + ' more to checkout';
    var skipMsg = container.querySelector('.cart-threshold__skip-state .cart-threshold__message');
    if (skipMsg) skipMsg.textContent = 'Add more items to cover ' + formatted;
    container.querySelectorAll('.cart-threshold__delta-value').forEach(function (span) {
      span.textContent = formatted;
    });
  }

  /* ========== Control ALL checkout buttons ========== */

  function controlCheckoutButtons(shouldBlock) {
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      btn.style.display = shouldBlock ? 'none' : '';
    });
    var drawerBtn = document.getElementById('CartDrawer-Checkout');
    if (drawerBtn) drawerBtn.style.display = shouldBlock ? 'none' : '';
    var pageBtn = document.getElementById('checkout');
    if (pageBtn) pageBtn.style.display = shouldBlock ? 'none' : '';
    var notifForm = document.getElementById('cart-notification-form');
    if (notifForm) notifForm.style.display = shouldBlock ? 'none' : '';
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.style.display = shouldBlock ? 'none' : '';
    });
    document.querySelectorAll('.shopify-payment-button').forEach(function (el) {
      el.style.display = shouldBlock ? 'none' : '';
    });
  }

  /* ========== Form submission interception ========== */

  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    var isCheckout = (submitter && submitter.name === 'checkout') ||
                     e.target.querySelector('button[name="checkout"]');
    if (!isCheckout) return;
    if (lastCartState) {
      var delta = THRESHOLD - lastCartState.original_total_price;
      var deltaDiscounted = THRESHOLD - lastCartState.total_price;
      var canCheckout = delta <= 0 || deltaDiscounted <= 0 ||
                        (delta < CHEAPEST && isLoggedIn);
      if (!canCheckout && lastCartState.item_count > 0) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/cart';
        return false;
      }
    }
  }, true);

  /* ========== Skip button ========== */

  function bindSkipButton(container) {
    var skipBtn = container.querySelector('[data-threshold-skip]');
    if (!skipBtn || skipBtn.hasAttribute('data-bound')) return;
    skipBtn.setAttribute('data-bound', 'true');
    skipBtn.addEventListener('click', function () {
      container.setAttribute('data-state', 'skipstate');
      controlCheckoutButtons(true);
    });
  }

  /* ========== Cross-sell add-to-cart ========== */

  function bindCrosssellButtons(container) {
    var addBtns = container.querySelectorAll('[data-crosssell-add]');
    addBtns.forEach(function (btn) {
      if (btn.hasAttribute('data-bound')) return;
      btn.setAttribute('data-bound', 'true');
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-crosssell-add');
        btn.textContent = 'Adding\u2026';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (cartEl) {
              if (typeof cartEl.onCartUpdate === 'function') cartEl.onCartUpdate();
            });
            /* refreshThreshold is triggered by fetch interceptor automatically */
          })
          .catch(function () {
            btn.textContent = '+ Add';
            btn.disabled = false;
          });
      });
    });
  }

  /* ========== Intercept ALL cart API calls ========== */
  /*
   * Key performance fix: read cart data directly from the API response
   * instead of making a second /cart.js request.
   *
   * /cart/change.js, /cart/update.js, /cart/clear.js → return full cart object
   * /cart/add.js → returns line item only, so we fetch /cart.js after
   */
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (typeof url !== 'string') return originalFetch.apply(this, arguments);

    var isCartChange = url.indexOf('/cart/change') !== -1 ||
                       url.indexOf('/cart/update') !== -1 ||
                       url.indexOf('/cart/clear') !== -1;
    var isCartAdd = url.indexOf('/cart/add') !== -1;
    var isCartFetch = url === '/cart.js' || url.indexOf('/cart.js') !== -1;

    /* Don't intercept our own /cart.js fetches to avoid loops */
    if (isCartFetch && !isCartChange && !isCartAdd) {
      return originalFetch.apply(this, arguments);
    }

    var result = originalFetch.apply(this, arguments);

    if (isCartChange) {
      /* Response IS the full cart — read it directly */
      result.then(function (response) {
        var cloned = response.clone();
        cloned.json().then(function (cart) {
          if (cart && typeof cart.total_price === 'number') {
            updateAllUI(cart);
          }
        }).catch(function () {});
      }).catch(function () {});
    } else if (isCartAdd) {
      /* /cart/add returns line item, not full cart — fetch cart after */
      result.then(function () {
        originalFetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateAllUI(cart); })
          .catch(function () {});
      }).catch(function () {});
    }

    return result;
  };

  /* ========== Initialize ========== */

  function init() {
    /* Initial cart state fetch */
    originalFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateAllUI(cart); })
      .catch(function () {});

    /* Watch for dynamically injected checkout/payment buttons */
    var observer = new MutationObserver(function () {
      /* Re-apply checkout button visibility based on last known state */
      if (lastCartState) {
        var delta = THRESHOLD - lastCartState.original_total_price;
        var deltaDiscounted = THRESHOLD - lastCartState.total_price;
        var shouldBlock = lastCartState.item_count === 0 ||
          (delta > 0 && deltaDiscounted > 0 && !(delta < CHEAPEST && isLoggedIn));
        controlCheckoutButtons(shouldBlock);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
